import React from "react";
import styled from "styled-components";

const Card = styled.div`
  width: 330px;
  min-height: 470px;
  background-color: ${({ theme }) => theme.card};
  cursor: pointer;
  border-radius: 14px;
  box-shadow: 0 0 12px 4px rgba(0, 0, 0, 0.28);
  overflow: hidden;
  padding: 22px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: all 0.25s ease-in-out;
  border: 1px solid rgba(253, 181, 21, 0.1);

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 0 30px 4px rgba(0, 0, 0, 0.35);
  }

  @media only screen and (max-width: 768px) {
    min-height: max-content;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 170px;
  object-fit: cover;
  background-color: ${({ theme }) => theme.white};
  border-radius: 12px;
  box-shadow: 0 0 16px 2px rgba(0, 0, 0, 0.2);
`;

const Tags = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;

const Tag = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.primary};
  background-color: rgba(253, 181, 21, 0.1);
  padding: 4px 8px;
  border-radius: 10px;
`;

const Details = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 2px;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Date = styled.div`
  font-size: 12px;
  margin-left: 2px;
  font-weight: 400;
  color: ${({ theme }) => `${theme.text_secondary}CC`};

  @media only screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

const Description = styled.div`
  font-weight: 400;
  color: ${({ theme }) => `${theme.text_secondary}DD`};
  overflow: hidden;
  margin-top: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  line-height: 1.6;
`;

const CertificateCard = ({ certificate }) => {
  return (
    <Card
      onClick={() => window.open(certificate.link, "_blank", "noopener,noreferrer")}
      role="button"
      tabIndex={0}
    >
      <Image src={certificate.image} alt={certificate.title} />
      <Tags>
        {certificate.tags?.map((tag, index) => (
          <Tag key={index}>{tag}</Tag>
        ))}
      </Tags>
      <Details>
        <Title>{certificate.title}</Title>
        <Date>{certificate.date}</Date>
        <Description>{certificate.description}</Description>
      </Details>
    </Card>
  );
};

export default CertificateCard;
